export const defaultFaq = [
    {
        question: "How do I know I'm applying for legitimate house sits?",
        answer: "All house sits on HouseSit Match are verified, and homeowners provide genuine reviews after each sit. We also offer ID verification for added security.",
    },
    {
        question: "Can I sit anywhere in the world?",
        answer: "Yes! HouseSit Match connects you with homeowners globally, so you can find sits in a variety of locations.",
    },
    {
        question: "Do I need experience to become a house sitter or pet sitter?",
        answer: "No experience is necessary, but we recommend showcasing any relevant skills or experience, especially with pets, on your profile.",
    },
    {
        question: "How long can I stay as a house sitter?",
        answer: "The duration of each sit depends on the homeowner's needs. Some sits are short-term (a weekend), while others may be longer (several weeks).",
    },
    {
        question: "What happens if I have an issue with a homeowner?",
        answer: "HouseSit Match offers support through our secure messaging system and customer service team to resolve any disputes or issues.",
    },
    {
        question: "",
        answer: "",
    },
];